import { render, staticRenderFns } from "./DevBpbjInfoList.vue?vue&type=template&id=3505906a&scoped=true&"
import script from "./DevBpbjInfoList.vue?vue&type=script&lang=js&"
export * from "./DevBpbjInfoList.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjInfoList.vue?vue&type=style&index=0&id=3505906a&scoped=true&lang=css&"
import style1 from "./DevBpbjInfoList.vue?vue&type=style&index=1&id=3505906a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3505906a",
  null
  
)

export default component.exports